"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostAgreementAdd = void 0;
const Base_1 = require("./Base");
exports.PostAgreementAdd = {
    url: Base_1.URL_BASE + "/AgreementAdd",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostAgreementAdd.js.map